//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "ConversationDetails__StyledFormattedMessage",
  componentId: "sc-1outnq1-0"
})(["padding-right:4px;"]);
const OpenThreadInformation = ({
  startedAt
}) => {
  return /*#__PURE__*/_jsx("span", {
    style: {
      whiteSpace: 'nowrap'
    },
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-header.openLabel",
      options: {
        duration: /*#__PURE__*/_jsx(FormattedDuration, {
          from: startedAt,
          to: null
        })
      }
    })
  });
};
const ClosedThreadInformation = ({
  closedAt
}) => {
  return /*#__PURE__*/_jsxs("span", {
    style: {
      whiteSpace: 'nowrap'
    },
    children: [/*#__PURE__*/_jsx(StyledFormattedMessage, {
      message: "svh-workspace-ui-lib.ticket-header.closedLabel"
    }), /*#__PURE__*/_jsx(FormattedDateTime, {
      value: closedAt,
      format: "ll"
    })]
  });
};
const ConversationDetails = ({
  startedAt,
  closedAt
}) => {
  return /*#__PURE__*/_jsx("span", {
    children: closedAt ? /*#__PURE__*/_jsx(ClosedThreadInformation, {
      closedAt: closedAt
    }) : /*#__PURE__*/_jsx(OpenThreadInformation, {
      startedAt: startedAt
    })
  });
};
ConversationDetails.displayName = 'ConversationDetails';
OpenThreadInformation.displayName = 'OpenThreadInformation';
ClosedThreadInformation.displayName = 'ClosedThreadInformation';
export default ConversationDetails;